import { CountryBankData } from '../country-bank-data';
import { Bank } from '../../bank';

export type GbBankDataItem = [string, string, string, string];

export class GbBankData extends CountryBankData<GbBankDataItem> {
  protected findEntry(bankId: string, branchId?: string) {
    return this._banks.find((b) => b[1] === branchId);
  }

  protected fromEntry(entry: GbBankDataItem) {
    return entry ? new Bank(entry[0], entry[2]) : undefined;
  }
}
